// extracted by mini-css-extract-plugin
export default {"container":"vk-z","bubbleNav":"wk-z","graphic":"xk-z","contact":"yk-z"};